// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"e906ce7d","239":"dff38bb0","455":"83535ac6","806":"16cd845c","977":"fc3e0a31"}[chunkId] + ".chunk.js";
};